import { get, post } from '../http/httpType';
import {
    appApiUrl,
    carManagementApiUrl,
    commercialApiUrl,
    commonApiUrl,
    messageSendApiUrl,
    organizationApiUrl,
    processApiUrl,
    projectApiUrlList,
    technicalApiUrl,
    faceApiUrl
} from './index';

export default {
    approvallist: post(appApiUrl + '/application/list'),
    getTodoList: post(processApiUrl + '/cms/task/userTasks'), // 待办事项列表
    getDownList: post(processApiUrl + '/cms/process/procInstFinisedTask'), // 已办事项列表
    getPageSysNotice: post(carManagementApiUrl + '/sysNotice/getPageSysNotice'), // 业务事项列表
    getTodoTotal: post(processApiUrl + '/cms/task/taskTypeCount'), // 待办总数量查询
    messagePage: post(messageSendApiUrl + '/message-send/page'), // 消息分页查询
    messageRead: post(messageSendApiUrl + '/message-send/read'), // 已读消息
    messageCountNum: post(messageSendApiUrl + '/message-send/countNum'), // 统计消息条数
    messageMyCountNum: post(processApiUrl + '/cms/process/procInstByStart'), // 我发起的消息
    messageMyCountNumDetail: get(processApiUrl + '/cms/process/queryActiveProcTaskInfo', 'add'), // 我发起的消息详情
    assignEmployee: post(commonApiUrl + '/process/assign-employee'), // 审批人
    completeTask: post(processApiUrl + '/cms/task/completeTask'), // 节点任务处理
    details: get(projectApiUrlList + '/design/plots/manage/list_detail'), // 项目设计策划书详情

    typeLabel: post(technicalApiUrl + '/technical/types-label'), // 类型下拉框
    programOptions: post(technicalApiUrl + '/technical/approval-management/query'), // 方案名称下拉框

    technicalDetails: get(technicalApiUrl + '/technical/approval-management/details'), // 施组(方案)审批详情
    submitTechnicalForm: post(technicalApiUrl + '/technical/approval-management/audit-assessment-form'), // 提交施组(方案)审批
    employeesList: get(projectApiUrlList + '/projects/employees/list'), // 编制人员
    submitScoreForm: post(projectApiUrlList + '/design/plots/manage/audit-assessment-form'), // 提交项目设计策划书审核表
    getOneOrgUsers: post(organizationApiUrl + '/employees/pages-by-org', null, { useApi: '' }), // 根据分公司查询人员
    getOrgEmployeesListBy: post(organizationApiUrl + '/employees/list-by'), //  获取员工列表信息
    fundReturn: get(commercialApiUrl + '/project-risk/fund-return/query'), //查看-项目风险金返还
    queryOrgByCurrentUser: post(organizationApiUrl + '/employees/queryOrgByCurrentUser'), // 获取当前登录人分公司
    queryProject: post(projectApiUrlList + '/projects/down-project'), // 选择审核通过的项目
    financeAudit: post(commercialApiUrl + '/project-risk/finance-audit'), // 新增项目风险金返还-公司财务资金部审批情况
    commercialAudit: post(commercialApiUrl + '/project-risk/commercial-audit'), // 新增项目风险金返还-公司商务管理部审批情况
    getAppPageCarDriverAssess: post(carManagementApiUrl + '/carDriverAssess/getAppPageCarDriverAssess'), //司机日常考核列表
    AddCarDriverAssess: post(carManagementApiUrl + '/carDriverAssess/insertSelective'), //新增司机日常考核
    getQueryAppRecord: post(carManagementApiUrl + '/carApplicationRecord/queryAppRecord'), //用车人评价列表
    updateStatus: get(carManagementApiUrl + '/carApplicationRecord/updateStatus'), //结束任务-APP
    addInsertSelective: post(carManagementApiUrl + '/carUsePersonScore/insertSelective'), //用车人评价表单
    getInsertSelective: get(carManagementApiUrl + '/carUsePersonScore/getCarUsePersonScoreById'), //获取用车人评价表单详情
    getPageOfficeCanteenProcurement: post(carManagementApiUrl + '/officeCanteenProcurement/getPageOfficeCanteenProcurement'), //食堂采购
    getInsertCanteenSelective: post(carManagementApiUrl + '/officeCanteenProcurement/insertSelective'), //添加食堂采购
    getOfficeCanteenByOrgId: get(carManagementApiUrl + '/officeCanteenProcurement/getOfficeCanteenByOrgId'), //获取采购供应商
    getOfficeCanteenProcurementById: get(carManagementApiUrl + '/officeCanteenProcurement/getOfficeCanteenProcurementById'), //获取食堂采购信息
    getOfficeCanteenProcurementByTime: get(carManagementApiUrl + '/officeCanteenProcurement/getOfficeCanteenProcurementByTime'), //获取食堂采购信息

    getQueryOfficeCanteenAppraiseList: post(carManagementApiUrl + '/officeCanteenAssessment/queryOfficeCanteenAssessmentList'), //食堂日常考核
    addCanteenAssessment: post(carManagementApiUrl + '/officeCanteenAssessment/insertSelective'), //添加食堂日常考核
    getCanteenAssessment: get(carManagementApiUrl + '/officeCanteenAssessment/getOfficeCanteenAssessmentById'), //获取食堂日常考核

    queryOfficeCanteenAppraiseList: post(carManagementApiUrl + '/officeCanteenAppraise/queryOfficeCanteenAppraiseList'), //用餐评价
    addCanteenEvaluate: post(carManagementApiUrl + '/officeCanteenAppraise/insertSelective'), //添加用餐评价
    getCanteenEvaluate: get(carManagementApiUrl + '/officeCanteenAppraise/getOfficeCanteenAppraiseById'), //获取用餐评价

    getPageOfficeCanteenPeople: post(carManagementApiUrl + '/officeCanteenPeople/getPageOfficeCanteenPeople'), //用餐人数
    addCanteenPeopleSelective: post(carManagementApiUrl + '/officeCanteenPeople/insertSelective'), //添加用餐人数
    getCanteenPeople: get(carManagementApiUrl + '/officeCanteenPeople/getOfficeCanteenPeopleById'), //获取用餐人数
    getOfficeCanteenPeopleByTime: get(carManagementApiUrl + '/officeCanteenPeople/getOfficeCanteenPeopleByTime'), //获取用餐是否已提交
    addCarApply: post(carManagementApiUrl + '/carApplication/insertSelective'), //用车申请提交
    carApplyList: post(carManagementApiUrl + '/carApplication/getPageCarApplication'),  // 用车申请列表
    carApplyDetail: get(carManagementApiUrl + '/carApplication/getCarApplicationById'),  // 用车申请详情
    carApplyProcessDetail: get(carManagementApiUrl + '/carApplication/getCarAndApplicationById'),  // 用车申请详情
    carApplyCreateBatch: post(carManagementApiUrl + '/carDispatchRecord/createBatch'),  // 用车申请调度
    addCarApplyAgain: post(carManagementApiUrl + '/carApplication/updateByPrimaryKeySelective'),  // 用车不通过二次申请
    carTask: get(processApiUrl + '/cms/process/queryActiveProcTaskInfo/', 'add'), //  用车申请节点任务处理
    getProcessGroupPerson: post(commonApiUrl + '/process/assign-employee/'), //  用车申请节点任务处理人

    // 人脸识别检测是否注册
    faceFindUserId: post(faceApiUrl + '/faceInfo/findUserId?userId=', 'add'),

    // 组织机构树

    getCustOrgTree: post('/ycloud-organization/orgs/cust-tree'),
    //根据多个组织查询人员
    getListByOrgs: post('/ycloud-organization/employees/list-by'),

    queryOrgByIdOrTags: post('/ycloud-organization/orgs/queryOrgByIdOrTags'), // 获取所有分公司
    userBranchProject: post('/cscec-project-business/projects/user-branch-project'), // 获取项目
    autoLogin: post('/cscec-pms-app-business/eighth/bureau/login'), // 自动登录
    getMsgDetail: (id)=>{
        return get('/ycloud-mbroker/message-send/detail/' + id)()
    }
}
